const rankingItems = [
  { rank: 1, title: '海贼王', subtitle: '尾田荣一郎', desc: '路飞与伙伴们在艾尔巴夫篇展开全新冒险，巨人族的秘密逐渐揭晓，世界格局迎来前所未有的巨变。', tag: '连载中', change: 0 },
  { rank: 2, title: '咒术回战', subtitle: '芥见下下', desc: '死灭回游篇高潮迭起，虎杖与宿傩的最终对决牵动无数读者的心，每一话都引发全网热议。', tag: '连载中', change: 1 },
  { rank: 3, title: '电锯人', subtitle: '藤本树', desc: '第二部持续高能输出，三鹰朝的命运走向扑朔迷离，藤本树独特的叙事手法让人欲罢不能。', tag: '连载中', change: -1 },
  { rank: 4, title: '间谍过家家', subtitle: '远藤达哉', desc: '福杰一家的温馨日常与间谍任务交织，安尼亚的校园生活让这部作品兼具笑点与温情。', tag: '连载中', change: 0 },
  { rank: 5, title: '坂本日常', subtitle: '铃木祐斗', desc: '看似平凡的便利店店员坂本太郎，实际上是传说中的最强杀手，日常与非日常的碰撞笑料百出。', tag: '连载中', change: 2 },
  { rank: 6, title: '葬送的芙莉莲', subtitle: '山田钟人/阿部司', desc: '勇者一行人击败魔王之后，精灵魔法使芙莉莲踏上了理解人类情感的漫长旅程，细腻感人。', tag: '连载中', change: -1 },
  { rank: 7, title: '怪兽8号', subtitle: '松本直也', desc: '中年大叔日比野卡夫卡意外获得变身怪兽的能力，在怪物横行的世界里追寻儿时梦想。', tag: '连载中', change: 1 },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            每周更新
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门排行
          </h2>
          <p className="text-foreground-500 text-sm mt-2">综合热度、讨论量与读者评分的日漫榜单</p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <article
              key={item.rank}
              className="group flex items-center gap-4 md:gap-6 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/70 hover:border-background-300 cursor-pointer transition-all"
            >
              <div className="flex-shrink-0 w-10 text-center">
                <span className={`font-heading text-2xl font-bold ${
                  item.rank <= 3 ? 'text-primary-500' : 'text-foreground-300'
                }`}>
                  {String(item.rank).padStart(2, '0')}
                </span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.subtitle}</span>
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-1">
                  {item.desc}
                </p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1">
                {item.change > 0 && <i className="ri-arrow-up-line text-primary-500 text-sm"></i>}
                {item.change < 0 && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                {item.change === 0 && <i className="ri-subtract-line text-foreground-300 text-sm"></i>}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}